<template>
  <financial-overview v-if="enabled"/>
  <legacy-dashboard v-else/>
</template>

<script>
import { mapState } from 'vuex';
import { isEnabled as isInsuranceBillingEnabled } from '@/app/billing/guide/service';

export default {
  components: {
    FinancialOverview: () => import(/* webpackChunkName: "financial-overview" */ './overview/Main.vue'),
    LegacyDashboard: () => import(/* webpackChunkName: "dashboard" */ './Dashboard.vue'),
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    enabled() {
      return isInsuranceBillingEnabled(this.user);
    },
  },
};
</script>
